import { t } from '../../../../../helpers/i18n';
import { CloseOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Space, Upload } from 'antd';
import type { RcFile } from 'antd/es/upload/interface';
import React, { useState } from 'react';
import './UploadLogo.scss';
import { UndefinedAble } from '../../../../../data/base';
import DefaultImage from 'assets/images/v2/ic_not_upload_project_logo.png';
import { showError } from "../../../../../store/popup/actions";
import { useDispatch } from "react-redux";

interface UploadLogoProps {
  onFileChange: (file: UndefinedAble<RcFile>) => void;
  imageUrl?: string;
}

const UploadLogo: React.FC<UploadLogoProps> = (props) => {
  const [imageBase64Content, setImageBase64Content] = useState<string>(
    props.imageUrl ?? ''
  );
  const [fileName, setFileName] = useState<string>('');
  const dispatch = useDispatch();

  const beforeUpload = (file: RcFile) => {
    const isNotJpgOrPng = file.type !== 'image/jpeg' && file.type !== 'image/png';
    if (isNotJpgOrPng){
      dispatch(showError(t('create_project_invalid_image_format_error')));
      return false
    }

    props.onFileChange(file);

    getBase64(file, (url) => {
      setImageBase64Content(url);
      setFileName(file.name);
    });
    return false; // prevent default upload file
  };

  const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const onDeleteLogo = () => {
    setImageBase64Content(props?.imageUrl ?? '');
    setFileName('');
    props.onFileChange(undefined);
  };

  return (
    <div className="logo_container">
      <Space style={{ height: '100%' }} align="center">
        {imageBase64Content ? (
          <img
            src={imageBase64Content}
            alt="Project Logo"
            className="upload-logo-preview-style"
          />
        ) : (
          <img
            src={DefaultImage}
            className="upload-logo-preview-style"
            alt="Project Logo"
          />
        )}

        <div style={{ marginLeft: '32px' }}>
          <Space align="center">
            <Upload
              name="avatar"
              listType="text"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              accept=".jpeg,.png,.jpg"
            >
              <Button icon={<UploadOutlined />}>
                {t('create_project_choose_image')}
              </Button>
            </Upload>

            {fileName && (
              <div className="upload-logo-selected-file-container-style">
                <CloseOutlined
                  onClick={onDeleteLogo}
                  style={{ fontSize: 18 }}
                />
                <p style={{ margin: '0 4px' }}>{fileName}</p>
              </div>
            )}
          </Space>
          <p className="upload-logo-description-style">
            {t('create_project_image_description')}
          </p>
        </div>
      </Space>
    </div>
  );
};

export default UploadLogo;
